<template>
  <div v-if="planner && !loading" class="full-height flex flex-column">
    <template v-if="routeMatchesComponent() && !contremarque">
      <div v-if="billetType === 'single-session'" class="flex h5n p1"> Pour échanger votre séance, sélectionner le nouveau créneau souhaité.</div>
      <!-- SESSIONS -->
      <div v-if="!loading" class="align-top col-12 flex flex-wrap thin-scroll">
        <!-- <div v-if="activity.isEmpty">Vous n'avez pas de créneau disponible.</div> -->

        <!-- MOBILE -->
        <div class="col-12 lg-hide flex flex-auto sticky top-75 z1">
          <div v-for="day in planner.days" :key="day" class="col-12 py1 center white-bg mb1 pointer border" :class="[ checkSelectedDay(day.day) ? 'selected': '' ]" @click="selectedDay = day.day">
            <h5 class="regular h6n m0 capitalize">{{ day.dayOfWeek.substring(0,3) }}.</h5>
            <h5 class="h6n m0">{{ day.day }}&nbsp;</h5>
          </div>
        </div>

        <div v-for="day in planner.days" :key="day" class="col-12 flex flex-column lg-hide">
          <div v-if="checkSelectedDay(day.day)" class="col-12 flex flex-wrap">
            <Session
              v-for="item in day.items"
              :key="item"
              class="col-12 px-small py-small"
              :activity-type="day.selectedActivityType"
              :item="item"
              :reserve-action="reserve.bind(this, item)"
              :cancel-action="cancel.bind(this, item)"
              :select-action="select.bind(this, item)"
              :exchange-action="exchange.bind(this, item)"
            />
          </div>
        </div>
        <!-- END OF MOBILE -->

        <!-- DESKTOP -->
        <div v-for="day in planner.days" :key="day" class="col-12 flex flex-auto flex-column xs-hide sm-hide md-hide" :class="planner.days.length === 7?'lg-col-calendar':`lg-col-${Math.floor(12/planner.days.length)}`">
          <div class="col-12 py2 center white-bg mb1 sticky top-75 z1">
            <h2 class="regular h6n my0 capitalize">{{ day.dayOfWeek }}</h2>
            <span class="h3n bold">{{ day.day }}</span>
          </div>

          <div class="col-12 flex flex-wrap">
            <Session
              v-for="item in day.items"
              :key="item"
              class="col-12 px-small py-small"
              :item="item"
              :activity-type="day.selectedActivityType"
              :exchange-action="exchange.bind(this, item)"
              :reserve-action="reserve.bind(this, item)"
              :cancel-action="cancel.bind(this, item)"
              :select-action="select.bind(this, {...item,selectedActivityType: day.selectedActivityType })"
            />
          </div>
        </div>
        <!-- END OF DESKTOP -->
      </div>
      <!-- END OF SESSIONS -->
    </template>

    <template v-else-if="contremarque">
      <div class="flex h5 bold col-12 center justify-center">
        Pour réserver, vous devez activer votre e-billet. Veuillez vous rendre à l’accueil du centre.
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { getCurrentInstance, provide, inject, computed, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { routeIsCurrentComponent } from '@/mixins/utils';

import Session from '@/components/reservations/Session';

export default {
  components: { Session },
  setup () {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const cancel = inject('cancel');
    const reserve = inject('reserve');
    const exchange = inject('exchange');
    const billetType = computed(() => store.state.billetType);

    const selectedDay = ref(0);

    const loading = computed(() => store.state.loadingContent);
    const contremarque = computed(() => store.state.contremarque);

    const selected = computed(() => store.state.selected);
    const selectedActivityKey = computed(() => store.state.selectedActivityKey);
    const selectedActivity = computed(() => (store.state.activities || []).filter(a => a.group === selectedActivityKey.value || a.name === selectedActivityKey.value));

    const findPlannerIndex = (plannerAux, day) => {
      const dayIndex = plannerAux.days.findIndex(value => value.day === `${day}`);
      return dayIndex === -1 ? plannerAux.days.length : dayIndex;
    };

    const planner = computed(() => {
      const plannerAux = { days: [] };
      if (selected.value && selected.value.length) {
        selected.value.map(s => {
          let foundActivity = null;
          foundActivity = selectedActivity.value.find(act => act.name === s);

          if (!foundActivity) {
            foundActivity = selectedActivity.value.find(act => act.group === s);
          }

          if (foundActivity && foundActivity.days && foundActivity.days.length) {
            foundActivity.days.map(day => {
              if (day.items && day.items.length) {
                const plannerIndex = findPlannerIndex(plannerAux, day.day);
                plannerAux.days[plannerIndex] = {
                  ...day,
                  selectedActivityType: foundActivity.type,
                  items: [...day.items, ...(plannerAux.days[plannerIndex] ? plannerAux.days[plannerIndex].items : [])]
                };
              }
            });
          }
        });
      } else {
        selectedActivity.value.map(act => {
          act.days.map((day, index) => {
            if (day.items && day.items.length) {
              if (!plannerAux.days[index]) {
                plannerAux.days[index] = {};
              }
              if (!plannerAux.days[index].items || !plannerAux.days[index].items.length) {
                plannerAux.days[index].items = [];
              }
              plannerAux.days[index] = {
                ...day,
                selectedActivityType: act.type,
                items: [...day.items, ...plannerAux.days[index].items]
              };
            }
          });
        });
      }

      plannerAux.days.sort((a, b) => a.index - b.index).map(day => {
        day.items.sort((a, b) => {
          let compare = a.startTimestamp - b.startTimestamp;
          if (!compare) {
            compare = a.type.localeCompare(b.type);
          }
          return compare;
        });
      });
      return plannerAux;
    });

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const checkSelectedDay = computed(() => day => {
      if (!planner.value.days.find(value => value.day === selectedDay.value)) return planner.value.days[0].day === day;
      return selectedDay.value === day || planner.value.days.length === 1;
    });

    const select = async session => {
      store.commit('setSession', session);
      if (route.name === 'SessionsPlanner') {
        router.push({ name: 'SessionActivityList' });
      } else if (route.name === 'GroupSessionsPlanner') {
        router.push({ name: 'GroupSessionActivityList' });
      }
    };

    return {
      selectedActivity,
      router,
      route,
      planner,
      loading,
      reserve,
      cancel,
      select,
      exchange,
      selectedDay,
      checkSelectedDay,
      routeMatchesComponent,
      contremarque,
      billetType
    };
  }
};
</script>

<style lang="scss" scoped>
.action:hover .breadcrumb-arrow{
  color: white;
}

.border{
  border:2px solid transparent
}

.selected{
  border: 2px solid #009a9b;
  color: #009a9b;
}

.top-75{
  top: 75px;
}
</style>
